import { useAppSelector } from "hooks/storeHooks"
import { useLocation } from "react-router-dom"
import { Box, Loader, NavLink, NavSection, Typography } from "@strapi/design-system"
import { BulletList, Dot } from "@strapi/icons"
import { INavSectionsItems, ProductCategoriesLink } from "./types"
import { useTranslation } from "react-i18next"

export const NavSectionCategories = () => {
  const { t } = useTranslation()
  const title = t("nav.products")
  const items = [
    {
      to: ProductCategoriesLink.MAKEUP,
      activePaths: [ProductCategoriesLink.MAKEUP, ProductCategoriesLink.GLASSES],
      label: t("nav.products"),
      icon: <BulletList />,
      isMain: true,
    },
  ]
  const location = useLocation()
  const productsCategories = useAppSelector((state) => state.products.productsCategories)
  const productsCategoriesLoading = useAppSelector(
    (state) => state.products.productsCategoriesLoading
  )
  const productsListIndex = productsCategories?.findIndex((el) => el.to === location.pathname) ?? -1

  const getLinkTo = (link: INavSectionsItems): string => {
    if (link.isMain && productsCategories && productsCategories.length > 0) {
      const found = productsCategories.find((cat) => cat.to === link.to)
      return found ? link.to : productsCategories[0].to
    }
    return link.to
  }

  return (
    <NavSection label={title} key={title}>
      {items.map((link) => (
        <NavLink
          target={"_self"}
          to={getLinkTo(link)}
          icon={link.icon}
          key={link.to}
          className={productsListIndex >= 0 ? "active" : ""}
        >
          <Typography>{link.label}</Typography>
        </NavLink>
      ))}

      {productsCategoriesLoading ? (
        <NavLink
          disabled={true}
          style={{
            marginLeft: "25px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            style={{
              maxHeight: "20px",
              display: "flex",
              alignItems: "center",
              maxWidth: "24px",
            }}
          >
            <Loader
              small
              style={{
                maxHeight: "24px",
                maxWidth: "24px",
              }}
            />
          </Box>
        </NavLink>
      ) : (
        productsCategories?.map(({ to, label }, ind) => (
          <NavLink
            key={label + to + ind}
            to={to}
            style={{ marginLeft: "25px" }}
            icon={
              <Dot
                style={{
                  width: "5px",
                  height: "5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "5px",
                }}
              />
            }
          >
            {label}
          </NavLink>
        ))
      )}
    </NavSection>
  )
}
